import { Box, useTheme } from '@wegroup/design-system';
import React from 'react';
import { use100vh } from 'react-div-100vh';
import styled from 'styled-components';
import { mq, mqh } from '../../../../common/src/utils/styledComponentsUtils';

// Components
import Plant1 from '../../assets/Plant1';
import Plant2 from '../../assets/Plant2';
import Plant3 from '../../assets/Plant3';
import Plant4 from '../../assets/Plant4';

interface Props {
  maxWidth: string;
  noPadding?: boolean;
}

const FlowerContainer: React.FC<React.PropsWithChildren<Props>> = ({
  maxWidth,
  children,
  noPadding = false,
  ...otherProps
}) => {
  const height = `${use100vh()}px`;

  const { colors } = useTheme();

  return (
    <Wrapper maxWidth={maxWidth} {...otherProps}>
      <Box display={{ base: 'none', md: 'block' }}>
        <LeftFrontplant color={colors.secondary[600]} />
        <LeftBackPlant color={colors.secondary[700]} />
        <RightFrontplant color={colors.primary[500]} />
        <RightBackPlant color={colors.secondary[700]} />
      </Box>
      <ChildrenWrapper noPadding={noPadding} height={height}>
        {children}
      </ChildrenWrapper>
    </Wrapper>
  );
};

const RightBackPlant = styled(Plant4)`
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translate(80%, -40%);
`;

const RightFrontplant = styled(Plant3)`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 2;
  transform: translate(90%, -60%);
`;

const LeftBackPlant = styled(Plant2)`
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translate(-75%, -40%);
`;

const LeftFrontplant = styled(Plant1)`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  transform: translate(-75%, -40%);
`;

const Wrapper = styled.div<{ maxWidth: string }>`
  position: relative;
  max-width: ${({ maxWidth }) => maxWidth};
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin: 1.6rem;

  ${mqh.custom(520)} {
    width: unset;
    margin: 0.8rem;

    ${mq.tablet} {
      width: 90vw;
      margin: 2rem;
    }
  }
`;

const ChildrenWrapper = styled.div<{ height?: string; noPadding: boolean }>`
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 10;
  border: ${({ theme }) => (theme['isImmo'] ? '1px solid lightgray' : 'none')};
  padding: ${({ noPadding }) => (noPadding ? '0' : '1.6rem')};
  border-radius: 10px;
  overflow: hidden;

  ${mqh.custom(520)} {
    width: '100%';
    ${mq.mobileM} {
      padding: ${({ noPadding }) => (noPadding ? '0' : '2.4rem')};
    }
    ${mq.mobileL} {
      padding: ${({ noPadding }) => (noPadding ? '0' : '3.2rem 4rem')};
      min-height: unset;
    }
  }

  ::-webkit-scrollbar {
    width: 0;
    background: transparent; /* make scrollbar transparent */
  }
`;

export default FlowerContainer;
